import { gql } from '@apollo/client'
import employeeDisplayTinyInfoFragment from './employeeDisplayTinyInfo.fragment'
import employeeSkillStatusFragment from '../../skill-status/employeeSkillStatus.fragment'

export default gql`
  fragment EmployeesAndAppraisals on EmployeeAndAppraisalMeetings {
    id
    status {
      name
      sortOrder
    }
    mandatory
    meetingToDoInCurrentAppraisalSeason
    country
    branchOfficeCode
    employee {
      id
      firstName
      lastName
      currentLevel
      companyName
      buName
      avatarUrl
      managers {
        id
        firstName
        lastName
        avatarUrl
      }
    }
    appraisal {
      id
      date
      hrFeedBack
      hrDisputeComment
      hrResult
      meetingStatus
      meetingType
      type {
        name
        reason
        skippedSteps
      }
      reviewer {
        ...EmployeeDisplayTinyInfo
      }
      confirmation {
        date
        discussedWith {
          ...EmployeeDisplayTinyInfo
        }
        forceConfirmedBy {
          ...EmployeeDisplayTinyInfo
        }
        forceConfirmedReason
      }
      conclusionPdf {
        fileName
        downloadToken
        status
      }
      appraisalSeason {
        id
        companyId
        country
        year
        fromDate
        toDate
      }
      companyNameOfMeeting
    }
    skillStatus {
      ...SkillStatusFragment
    }
  }
  ${employeeDisplayTinyInfoFragment}
  ${employeeSkillStatusFragment}
`
